import { render, staticRenderFns } from "./Praise.vue?vue&type=template&id=75127f0e&scoped=true&"
import script from "./Praise.vue?vue&type=script&lang=js&"
export * from "./Praise.vue?vue&type=script&lang=js&"
import style0 from "./Praise.vue?vue&type=style&index=0&id=75127f0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75127f0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/yx-web-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75127f0e')) {
      api.createRecord('75127f0e', component.options)
    } else {
      api.reload('75127f0e', component.options)
    }
    module.hot.accept("./Praise.vue?vue&type=template&id=75127f0e&scoped=true&", function () {
      api.rerender('75127f0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Activity/Children/StatisticsChildren/Praise.vue"
export default component.exports